'use strict';

import { GetSpriteSvg } from './module/GetSpriteSvg';
import { Lights } from './module/Lights';
import { LuxySet } from './module/LuxySet';
import { Anchor } from './module/Anchor';
import { Menu } from './module/Menu';
import { Modal } from './module/Modal';
import { TimerSet } from './module/TimerSet';
import { setSwiper } from './module/setSwiper';

GetSpriteSvg();

document.addEventListener('DOMContentLoaded', () => {
	Lights();
	Anchor();
	Menu();
	Modal();
	TimerSet();
	setSwiper();

	// luxy

	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('iPhone') > 0 || ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0) {
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
  } else if(ua.indexOf("safari") !== -1 && ua.indexOf('chrome') === -1){
  } else {
		LuxySet();
  }

});
